// Picks the AI drawing UI base URL to open, failing over to the secondary
// one when the primary is unreachable. Used only when the backend didn't
// already return a resolved aiUrl (see aiSessionCtrl.js).
const CHECK_TIMEOUT_MS = 2500;

async function isReachable(url) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), CHECK_TIMEOUT_MS);
  try {
    // no-cors: the response body/status is opaque, but a resolved fetch
    // means a server actually answered. Only network failures (down host,
    // refused connection, timeout) land in the catch.
    await fetch(url, { method: 'HEAD', mode: 'no-cors', signal: controller.signal });
    return true;
  } catch (err) {
    return false;
  } finally {
    clearTimeout(timer);
  }
}

export async function resolveAiDrawingUiBaseUrl() {
  const primary = (process.env.REACT_APP_AI_DRAWING_UI_URL || '').replace(/\/+$/, '');
  const fallback = (process.env.REACT_APP_AI_DRAWING_UI_URL_1 || '').replace(/\/+$/, '');

  for (const url of [primary, fallback]) {
    if (url && await isReachable(url)) return url;
  }
  return null;
}
